const accountTypeOptions = [
    {
        id: 1,
        name: '试用',
    },
    {
        id: 2,
        name: '正常',
    },
]
const statusOptions = [
    {
        id: 1,
        name: '待确认',
    },
    {
        id: 2,
        name: '合同签订',
    },
    {
        id: 3,
        name: '已回款',
    },
    {
        id: 4,
        name: '已开通',
    },
]

const appPkgOptions = [
    {
        value: 0,
        label: '否',
    },
    {
        value: 1,
        label: '是',
    },
]

export { accountTypeOptions, statusOptions, appPkgOptions }
